import React, { Fragment, useState } from 'react';
import { useIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga';

import styles from './Header.module.css';
import { ReactComponent as Logo } from './logo.svg';
import { ModalConsumer } from '../Modal/ModalContext';
import RequestModal from '../RequestModal';

const Header = (props) => {

  const { gaValue } = props;

  const { formatMessage } = useIntl();
  const { config: { links } } = useSelector(state => state.config);

  const [ showMenu, setShowMenu ] = useState(false);

  return (
    <>
      <MediaQuery minDeviceWidth={1224}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <a href={links.logo} target="_blank" rel="noopener noreferrer">
              <Logo/>
            </a>
          </div>
          <div className={styles['middle-container']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.corporateWebsite}  target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Header.corporateWebsite'}) }
            </a>
            <a className={`${styles.link} Rubik-20pt`} href={links.solutions} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Header.solutions'}) }
            </a>
            <a className={`${styles.link} Rubik-20pt`} href={links.aboutUs} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Header.about'}) }
            </a>
          </div>
          <div className={styles['ask-button-container']}>
            <ModalConsumer>
              {({showModal}) => (
                <Fragment>
                  <button className={`${styles['ask-button']} Rubik-20pt`} onClick={() => {
                    gaValue && ReactGA.set({ dimension1: gaValue });
                    showModal(RequestModal);
                  }}>
                    { formatMessage({id: 'Header.askAnExpert'}) }
                  </button>
                </Fragment>
              )}
            </ModalConsumer>
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={1224}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <a href={links.logo} target="_blank" rel="noopener noreferrer">
              <Logo/>
            </a>
          </div>
          <div className={styles['menu-expand']}>
            <button
              onClick={() => setShowMenu(true)}
              className={styles['menu-expand-icon']}>&#xf0c9;</button>
          </div>
        </div>
        <div className={`${styles['menu']} ${showMenu ? '' : styles['menu-hidden']}`}>
          <div className={styles['menu-collapse']}>
            <button
              onClick={() => setShowMenu(false)}
              className={styles['menu-collapse-icon']}>&#xf00d;</button>
          </div>
          <div className={styles['divider']}></div>
          <div className={styles['menu-item']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.corporateWebsite}  target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Header.corporateWebsite'}) }
            </a>
          </div>
          <div className={styles['menu-item']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.solutions} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Header.solutions'}) }
            </a>
          </div>
          <div className={styles['menu-item']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.aboutUs} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Header.about'}) }
            </a>
          </div>
          <div className={styles['menu-item']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.privacyPolicy} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Footer.privacyPolicy'}) }
            </a>
          </div>
          <div className={styles['menu-item']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.cookiesPolicy} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Footer.cookiesPolicy'}) }
            </a>
          </div>
          <div className={styles['menu-item']}>
            <a className={`${styles.link} Rubik-20pt`} href={links.contacts} target="_blank" rel="noopener noreferrer">
              { formatMessage({id: 'Footer.contact'}) }
            </a>
          </div>
          <div className={styles['menu-item']}>
            <div className={styles['ask-button-container']}>
              <ModalConsumer>
                {({showModal}) => (
                  <Fragment>
                    <button className={`${styles['ask-button']} Rubik-20pt`} onClick={() => showModal(RequestModal)}>
                      { formatMessage({id: 'Header.askAnExpert'}) }
                    </button>
                  </Fragment>
                )}
              </ModalConsumer>
            </div>
          </div>
        </div>
      </MediaQuery>
    </>
  );
};

export default Header;
